import { useDispatch } from "react-redux";
import { uiActions } from "../../store/Ui-slice";

const NavbarHamburger = () => {
  const dispatch = useDispatch();
  const menuHamburgerHandler = () => {
    dispatch(uiActions.toggleHambargerModal());
  };
  return (
    <button
      type="button"
      onClick={menuHamburgerHandler}
      className="inline-flex items-center justify-center w-10 h-10 shrink-0 rounded-full bg-white text-slate-600 shadow-sm border border-slate-100 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-emerald-200 transition"
    >
      <span className="sr-only">Open main menu</span>
      <svg
        className="w-5 h-5"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
          clipRule="evenodd"
        ></path>
      </svg>
    </button>
  );
};

export default NavbarHamburger;
